import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { setApproveAndSendSaleInvoiceToCustomer } from '../services/setApproveAndSendSaleInvoiceToCustomer';


export const approveAndSendSaleInvoiceToCustomer = createAsyncThunk(
  'saleInvoices/approveAndSendSaleInvoiceToCustomer',
  async (params, { getState, dispatch }) => {
    console.log('params', params);
    const { saleInvoiceId } = params;

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await setApproveAndSendSaleInvoiceToCustomer(
      selectedProjectId,
      saleInvoiceId
    );
    console.log('response', response);
    return response;
  }
);
